import { ErrorMessage } from "../components/ErrorMessage";
import { useStats } from "../hooks/useStats";
import { WarehouseTable } from "../components/stats/WarehouseTable";
import { HelpText } from "../components/HelpText";

export const StatsPage = () => {
  const { data, isLoading, error } = useStats();

  return (
    <>
      {isLoading && <HelpText>Ładowanie danych...</HelpText>}
      {error && <ErrorMessage>Wystąpił błąd podczas ładowania danych.</ErrorMessage>}
      {data && (
        <>
        <HelpText>Znaczenie kolorów kwadratów (miejsc paletowych): zielony - wolne, czerwony - zajęte, zółty - niepełny EAN, szary - stan 0 szt.</HelpText>
          {Object.entries(data).map(([warehouseKey, warehouse]: [string, any]) => (
            <WarehouseTable key={warehouseKey} warehouseKey={warehouseKey} warehouse={warehouse} />
          ))}
        </>
      )}
    </>
  );
};
